import { useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { MENU_MODAL1, MENU_MODAL2 } from 'src/assets/database/webData';
import { popupNavigateState } from 'src/recoils/user-web.atom';

import { FlexBox } from 'src/styles/OverviewStyle';
import styled from 'styled-components';

export default function WebMenuBoardModal({
  setCurrentBtnId,
  setCurrentMenu,
  setShowEntireModal,
  kind,
}: {
  setCurrentBtnId: React.Dispatch<React.SetStateAction<number>>;
  setCurrentMenu: React.Dispatch<React.SetStateAction<string>>;
  setShowEntireModal: React.Dispatch<React.SetStateAction<boolean>>;
  kind: string;
}) {
  const [showModal, setShowModal] = useState(true);
  const setPopupNavigate = useSetRecoilState(popupNavigateState);
  if (showModal)
    return (
      <ModalContainer>
        <ModalTitle>{kind === 'buy' ? '살거리' : '먹거리'} 확인하기</ModalTitle>
        <ModalExplanation>
          제주들불축제 {kind === 'buy' ? '좋은 살거리' : '맛있는 먹거리'}를
          확인하세요
        </ModalExplanation>
        <ModalImgBoard>
          <img
            onClick={() => {
              setCurrentBtnId(5);
              setCurrentMenu('menuBoard');
              setShowModal(false);
              setShowEntireModal(false);
              if (kind === 'eat') setPopupNavigate(true);
              window.scrollTo(0, 0);
            }}
            src={kind === 'buy' ? MENU_MODAL1 : MENU_MODAL2}
            alt="이미지"
          />
          <ButtonBox>
            <CloseButton onClick={() => setShowModal(false)}>
              팝업 닫기
            </CloseButton>
          </ButtonBox>
        </ModalImgBoard>
      </ModalContainer>
    );
  return null;
}

const ModalContainer = styled(FlexBox)`
  position: fixed;
  top: 10%;
  left: 5%;
  z-index: 10;
  background-color: ${({ theme }) => theme.colors.backgroundColor};

  border-radius: 16px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.8);

  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const ModalTitle = styled.h1`
  margin-top: 12px;

  color: ${({ theme }) => theme.colors.fontColor};
  text-align: center;
  font-family: Cafe24Ohsquare;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 33.6px */
`;

const ModalExplanation = styled.h2`
  margin-bottom: 12px;

  color: #101010;
  text-align: center;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 18.2px */
`;

const ModalImgBoard = styled(FlexBox)`
  width: 100%;
  padding: 16px 0;
  background-color: white;

  padding: 16px 20px;
  border-radius: 0px 0px 16px 16px;

  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 28px;
  img {
    width: 328px;
    height: auto;
    cursor: pointer;
  }
`;

const ButtonBox = styled(FlexBox)`
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 4%;
`;

const CloseButton = styled.button`
  width: 100%;
  padding: 12px;

  border-radius: 8px;
  background: #101010;

  color: #fff;
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 21px */
  letter-spacing: -0.225px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;
